import actionTypes from '../constants/action-types';

const setCategories = (categories) => ({
  type: actionTypes.SET_CATEGORIES,
  payload: {
    categories,
  },
});

export default setCategories;
